import Vue from 'vue';

// leaflet stuff
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import axios from 'axios';

import App from './App.vue';
import router from './router';
import store from './store/store';
import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import VueAnalytics from 'vue-analytics';

// leaflet config
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  // eslint-disable-next-line global-require
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  // eslint-disable-next-line global-require
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  // eslint-disable-next-line global-require
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

// axios (HTTP requests, mostly to backend) settings
Vue.prototype.$http = axios;
axios.defaults.baseURL = 'https://api.foraje.com/';

Vue.config.productionTip = false;

// Google Analytics hookup
Vue.use(VueAnalytics, {
  id: 'UA-121665514-1',
  router,
  // debug helps you to see events in the console
  // so you know that something is happening
  debug: {
    enabled: false,
  },
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');
